// Pack de unidades: al seleccionar una tarjeta, fija la cantidad real del form.
(function () {
  function initSection(root) {
    var form = root.querySelector('#me-product-form, .me-product__form');
    if (!form) return;
    var qb = root.querySelector('[data-me-qb]');
    if (!qb) return;

    // input cantidad real (Shopify lee name="quantity"); lo creamos si no existe
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';
      form.appendChild(qtyInput);
    }
    // input variante (Shopify/Releasit leen name="id"): cada pack es una VARIANTE
    // con su propio precio, así que al elegir un pack cambiamos la variante, no la
    // cantidad. Cantidad siempre = 1.
    var idInput = form.querySelector('.me-product__variant-id') || form.querySelector('input[name="id"]');

    function sync() {
      var checked = qb.querySelector('input[name="me-qty"]:checked');
      var vid = checked ? checked.getAttribute('data-variant-id') : null;
      if (vid && idInput) idInput.value = vid;
      qtyInput.value = '1';
      qb.querySelectorAll('.me-qb__card').forEach(function (c) {
        var r = c.querySelector('input[name="me-qty"]');
        c.classList.toggle('is-selected', !!(r && r.checked));
      });
    }

    qb.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'me-qty') sync();
    });
    sync();

    var skipCart = root.getAttribute('data-skip-cart') === 'true';
    if (skipCart) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[name="add"]');
        if (btn) btn.setAttribute('disabled', 'disabled');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            if (btn) btn.removeAttribute('disabled');
            window.location.href = '/cart';
          });
      });
    }

    var sticky = root.querySelector('[data-me-sticky]');
    if (sticky) {
      var atcBtn = form.querySelector('[name="add"]');
      var stickyBtn = sticky.querySelector('[data-me-sticky-btn]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(atcBtn);
        else form.submit();
      });
      var onScroll = function () {
        var rect = atcBtn ? atcBtn.getBoundingClientRect() : null;
        var show = rect ? (rect.bottom < 0 || rect.top > window.innerHeight) : false;
        if (show) sticky.removeAttribute('hidden'); else sticky.setAttribute('hidden', '');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  document.querySelectorAll('.me-product').forEach(initSection);
})();
